package com.fireavert.administration.yardi_integration_page.yardi_data_import_section.client.presentation

import com.fireavert.administration.yardi_integration_page.yardi_data_import_section.client.YardiPropertyImportInteractor

/**
 * Controller for Yardi Property Data Import functionality.
 * Acts as a pass-through to the Interactor, similar to YardiCommonDataController.
 */
class YardiPropertyImportController(
    private val interactor: YardiPropertyImportInteractor
) {
    suspend fun onLoad() = interactor.onLoad()

    /**
     * Refresh the list of Yardi properties for the selected credentials
     */
    suspend fun refreshYardiProperties(credentialsId: Int, propertyId: String) =
        interactor.refreshYardiProperties(credentialsId, propertyId)

    /**
     * Load unit names from Yardi for the selected property
     */
    suspend fun loadYardiUnitNames(credentialsId: Int, propertyId: String) =
        interactor.loadYardiUnitNames(credentialsId, propertyId)

    /**
     * Load unit names from the dashboard for the selected property
     */
    suspend fun loadDashboardUnitNames(propertyId: Int) =
        interactor.loadDashboardUnitNames(propertyId)

    /**
     * Start the data import process
     */
    suspend fun startDataImport(
        propertyId: String,
        credentialsId: Int,
        yardiPropertyId: String,
        parsingMethod: String,
        yardiUnitNames: List<String>,
        dashboardUnitNames: List<String>
    ) = interactor.startDataImport(
        propertyId = propertyId,
        credentialsId = credentialsId,
        yardiPropertyId = yardiPropertyId,
        parsingMethod = parsingMethod,
        yardiUnitNames = yardiUnitNames,
        dashboardUnitNames = dashboardUnitNames
    )

    /**
     * Get the import status and results
     */
    suspend fun getImportResults(importId: String) =
        interactor.getImportResults(importId)

    /**
     * Cancel an ongoing import
     */
    suspend fun cancelImport(importId: String) =
        interactor.cancelImport(importId)
}